import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs operators
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  // Create the base URL to be used for all requests from environment variables
  private baseUrl: string = "https://cashbackswebapicore.whitedune-47840e2f.westeurope.azurecontainerapps.io";
  //private baseUrl: string = "https://localhost:44325";

  /**
   * Constructor
   *
   * @param 'httpClient'
   */
  constructor(
    protected httpClient: HttpClient){
  }

  /**
   * Standardized RMS GET request
   *
   * @param 'uri'
   * @param 'options'
   */
  get(uri: string, options = {}): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + uri, options)
      .pipe(catchError(this.handleError));
  }

  /**
   * Standardized RMS PUT request
   *
   * @param 'uri'
   * @param 'data'
   * @param 'options'
   */
  put(uri: string, data: any, options = {}): Observable<any> {
    return this.httpClient
      .put(this.baseUrl + uri, data, options)
      .pipe(catchError(this.handleError));
  }

  /**
   * Standardized RMS POST request
   *
   * @param 'uri'
   * @param 'data'
   * @param 'options'
   */
  post(uri: string, data: any, options = {}): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + uri, data, options)
      .pipe(catchError(this.handleError));
  }

  /**
   * Standardized RMS DELETE request
   *
   * @param 'uri'
   * @param 'options'
   */
  delete(uri: string, options = {}): Observable<any> {
    return this.httpClient
      .delete(this.baseUrl + uri, options)
      .pipe(catchError(this.handleError));
  }

  /**
   * Handle general errors from the API
   *
   * @param 'err'
   * @returns returns
   */
  private handleError(err: any) {
    return throwError(() => err);
  }
}
